<template>
  <div>
    <cover :pageData="pageData"></cover>
    <div class="page">
      <div class="title">
        <div class="cn_title">{{ pageData.firstTitle }}{{ pageData.secondTitle }}</div>
        <div class="en_title">{{ pageData.en_title }}</div>
      </div>
      <div class="body">
        <el-form label-width="80px">
          <el-row>
            <el-col :span="11">
              <el-form-item>
                <el-input v-model="submitData.phone" placeholder='您的联系电话*'></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item style="width: 601px;">
                <el-input v-model="submitData.name" placeholder='您的姓名'></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-form-item prop="desc" style="width: 1190px;">
              <el-input type="textarea" v-model="submitData.details" placeholder="留言内容"></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-col :span="19">
              <el-form-item>
                <el-input v-model="submitData.code" placeholder='验证码' style="width: 1020px;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item>
                <div class="code_img" @click="getCodeData()">{{ code }}</div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <Button class="submit" @click="submit">提交</Button>
        <div class="body_bottom">
          <div class="bottom_body">
            <div class="body_bottom_left">
              <div class="contact_en_title">CONTACT INFORMATION</div>
              <div class="contact_cn_title">联系信息</div>
              <div class="rowline"></div>
              <div class="contact_data">
                <span>传真：{{ contact.fax }}</span>
                <span>邮箱：{{ contact.email }}</span>
                <span>地址：{{ contact.address }}</span>
                <span>服务保障基地：{{ contact.serviceBase }}</span>
              </div>
            </div>
<!--              <div class="mapBox" id="Map"></div>-->
              <div class="mapBox"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var map = "";

import { getCode, submitData, getContactUs } from "@/server/https.js";
const https = require("../../vue.config");
import cover from '../components/cover.vue'
export default {
  name: '',
  components: {
    cover
  },
  data() {
    return {
			pageData: {
				firstTitle: '',
				secondTitle: '',
				bannerImg:'',
				des: ''
			},
      submitData: {
        uuid: '',
        code: '',
        name: '',
        phone: '',
        details: '',
        code: ''
      },
      code: '',
      contact: {
      }
    }
  },
  created() {
    getContactUs().then(res => {
      let contactUs = res.data.body.contactUs;
      this.contact = contactUs;
      // map = new BMap.Map("Map");
      // var point = new BMap.Point(this.contact.longitude, this.contact.latitude);
      // map.addControl(new BMap.NavigationControl());
      // map.addControl(new BMap.ScaleControl());
      // map.addControl(new BMap.OverviewMapControl());
      // map.enableScrollWheelZoom();
      // map.centerAndZoom(point, 15); // 编写自定义函数，创建标注
      // this.addMarker(point, 48, 48);
      // map.setMapStyle({
      //   styleJson: [
      //     {
      //       featureType: "all",
      //       elementType: "all",
      //       stylers: {
      //         lightness: 10,
      //         saturation: -100
      //       }
      //     }
      //   ]
      // });
      // var opts = {
      //   position: point, // 指定文本标注所在的地理位置
      //   offset: new BMap.Size(-90, 20) //设置文本偏移量
      // };
      // var label = new BMap.Label(contactUs.name, opts); // 创建文本标注对象
      // label.setStyle({
      //   color: "#000",
      //   fontSize: "12px",
      //   height: "20px",
      //   lineHeight: "20px",
      //   fontFamily: "微软雅黑",
      //   border: "none",
      //   background: "rgba(255,255,255,0.4)"
      // });
      // map.addOverlay(label);
    });
  },
  mounted() {
    this.getCodeData();
    var setI = setInterval(() => {
      if (this.$store.state.headList != '') {
        var headList = this.$store.state.headList
        headList.map(item => {
          if (item.sort == 7) {
            let Name = item.name;
            this.pageData.firstTitle = Name.slice(0, -2);
            this.pageData.secondTitle = Name.substr(-2);
            this.pageData.bannerImg = item.image;
            this.pageData.des=item.details;
          }
        })
        clearInterval(setI)
      }
    }, 200)
  },

  methods: {
    getCodeData() {
      getCode().then(res => {
        this.code = res.data.body.code;
        this.submitData.uuid = res.data.body.uuid;
      })
    },
    submit() {
      submitData(this.submitData).then(res => {
        if(res.data.msg=='操作成功'){
          this.$message.success(res.data.msg);
        }
        else{
                    this.$message.error(res.data.msg);

        }
      })
    },
    addMarker(point, w, h) {
      // 创建图标对象
      // var myIcon = new BMap.Icon(
      //   require("../assets/img/address-c.png"),
      //   new BMap.Size(w, h),
      //   {
      //     anchor: new BMap.Size(w / 1, h / 1),
      //     imageOffset: new BMap.Size(0, 0)
      //   }
      // );
      // var marker = new BMap.Marker(point, {
      //   icon: myIcon
      // });
      // map.addOverlay(marker);
    }
  }
};
</script>

<style scoped>
.page {
  height: 100%;
  position: relative;
  background: #FFFFFF;
  margin-top: 3rem;
}

.title {
  display: flex;
  justify-content: center;
  align-items: center;
}

.cn_title {
  position: absolute;
  font-size: 48px;
  font-weight: bold;
  color: #13489D;
  margin-top: 56px;
  z-index: 2;
}

.en_title {
  position: absolute;
  font-size: 54px;
  font-weight: bold;
  color: #C8D4E1;
  margin-top: 56px;
}

.body {
  margin-top: 160px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.code_img {
  background-color: rgb(230, 230, 230);
  width: 100px;
  text-align: center;
  color: rgb(255, 62, 62);
  font-size: 16px;
  font-weight: 800;
}

.submit {
  width: 96px;
  height: 36px;
  background: #13489D;
  border-radius: 18px;
  color: #FFFFFF;
}

.body_bottom {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 708px;
  margin-top: 20px;
  background: #F7F8FA;
}

.body_bottom_left {
  width: 400px;
  height: 550px;
}

.body_bottom_right {
  width: 750px;
  height: 550px;
  background-color: rgb(138, 255, 249);
}

.contact_en_title {
  margin-top: 50px;
  font-size: 30px;
  font-weight: bold;
  color: #999999;
}

.contact_cn_title {
  margin-top: 30px;
  font-size: 30px;
  font-weight: 500;
  color: #333333;
}

.bottom_body {
  overflow: hidden;
  height: 550px;
  width: 1200px;
  display: flex;
  justify-content: center;
}

.rowline {
  margin-top: 30px;
  width: 50px;
  height: 10px;
  background: #13489D;
  /* display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 1rem; */
}

.contact_data {
  display: flex;
  flex-direction: column;
  margin-top: 50px;
}

.contact_data span {
  margin-top: 20px;
  font-size: 16px;
  font-weight: 400;
  color: #333333;
}
.mapBox {
  margin-left: 20px;
  width: 750px;
  height: 550px;
  /* margin-bottom: 0.78rem; */
  /* background-color: #fff; */
}
</style>
